/** @format */

import React, { FC, memo } from "react";
import styled from "styled-components";
import { BoxProps } from "./Box.types";

const Wrapper = styled.div<BoxProps>`
  display: ${({ display }) => display || "flex"};

  position: ${({ position }) => position || "relative"};
  top: ${({ top }) => top || undefined};
  bottom: ${({ bottom }) => bottom || undefined};

  left: ${({ left }) => left || undefined};
  right: ${({ right }) => right || undefined};
  height: ${({ height }) => height || "auto"};
  min-height: ${({ minHeight }) => minHeight || "initial"};
  max-height: ${({ maxHeight }) => maxHeight || "initial"};

  width: ${({ width }) => width || "auto"};
  min-width: ${({ minWidth }) => minWidth || "initial"};
  max-width: ${({ maxWidth }) => maxWidth || "initial"};

  overflow: ${({ overflow }) => overflow || "visible"};
  overflow-x: ${({ overflowX }) => overflowX || "visible"};
  overflow-y: ${({ overflowY }) => overflowY || "visible"};

  margin: ${({ margin }) => margin || "0"};
  margin-top: ${({ marginTop }) => marginTop || ""};
  margin-bottom: ${({ marginBottom }) => marginBottom || ""};
  margin-left: ${({ marginLeft }) => marginLeft || ""};
  margin-right: ${({ marginRight }) => marginRight || ""};
  margin-block: ${({ marginBlock }) => marginBlock || ""};
  margin-inline: ${({ marginInline }) => marginInline || ""};

  padding: ${({ padding }) => padding || "0"};
  padding-top: ${({ paddingTop }) => paddingTop || ""};
  padding-bottom: ${({ paddingBottom }) => paddingBottom || ""};
  padding-left: ${({ paddingLeft }) => paddingLeft || ""};
  padding-right: ${({ paddingRight }) => paddingRight || ""};
  padding-block: ${({ paddingBlock }) => paddingBlock || ""};
  padding-inline: ${({ paddingInline }) => paddingInline || ""};

  border-radius: ${({ borderRadius }) => borderRadius || ""};

  align-items: ${({ alignItems }) => alignItems || null};
  justify-content: ${({ justifyContent }) => justifyContent || null};
  gap: ${({ gap }) => gap || null};
  flex-wrap: ${({ flexWrap }) => flexWrap || null};
  flex-direction: ${({ flexDirection }) =>
    flexDirection === "column" ? "column" : "row"};
  flex: ${({ flex }) => flex || null};
  flex-flow: ${({ flexFlow }) => flexFlow || null};
  flex-grow: ${({ flexGrow }) => flexGrow || null};
  flex-shrink: ${({ flexShrink }) => flexShrink || null};
  flex-basis: ${({ flexBasis }) => flexBasis || null};

  grid-template-columns: ${({ gridTemplateColumns }) =>
    gridTemplateColumns || null};
  grid-template-rows: ${({ gridTemplateRows }) => gridTemplateRows || null};
  grid-area: ${({ gridArea }) => gridArea || null};

  z-index: ${({ zIndex }) => zIndex || undefined};
  transform: ${({ transform }) => transform || undefined};
  pointer-events: ${({ pointerEvents }) => pointerEvents || undefined};
  cursor: ${({ cursor }) => cursor || undefined};
  box-sizing: border-box;
  transition: ${({ transition }) => transition || undefined};
  text-align: ${({ textAlign }) => textAlign || undefined};
  background: ${({ background }) => background || undefined};
  background-color: ${({ backgroundColor }) => backgroundColor || undefined};
  opacity: ${({ opacity }) => opacity || undefined};
`;

const Box: FC<BoxProps> = ({
  id,
  children,
  onClick,
  onMouseEnter,
  onMouseLeave,
  dataCy,
  ...props
}) => {
  return (
    <Wrapper
      {...props}
      id={id}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-cy={dataCy}
    >
      {children}
    </Wrapper>
  );
};

export default memo(Box);
